module.exports = __webpack_public_path__ + "img/secondary_11x3_z16.f5d2aae2.svg";